import { render, staticRenderFns } from "./ReviewStoryList.vue?vue&type=template&id=2c10d496&scoped=true"
import script from "./ReviewStoryList.vue?vue&type=script&lang=js"
export * from "./ReviewStoryList.vue?vue&type=script&lang=js"
import style0 from "./ReviewStoryList.vue?vue&type=style&index=0&id=2c10d496&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10d496",
  null
  
)

export default component.exports